module.exports = __webpack_public_path__ + "media/images/flags/64/Montenegro-cee69d2c746b351b126a843964cc3736.png";